import { Card, H1, HTMLTable } from "@blueprintjs/core";
import { css } from "glamor";
import * as React from "react";
import Loading from "src/Loading";
import { getTeamRanking } from "../api";

const styles = {
	container: css({ width: "100%" }),
	table: css({ width: "100%" }),
	title: css({ textAlign: "left" }),
	empty: css({ textAlign: "left" }),
	mobileMargin: css({
		"@media (max-width: 780px)": {
			marginLeft: "20px",
			marginRight: "20px",
		},
	}),
};

interface Team {
	name: string;
	points: number;
}
interface State {
	ranking: Team[];
	isEmpty: boolean;
}
interface Props {
	match: { params: { round: any } };
	dark: boolean;
}

export default class Ranking extends React.Component<Props, State> {
	public state = { ranking: [] as Team[], isEmpty: false };
	public async componentDidMount() {
		const round = this.props.match.params.round;
		const { ranking, isEmpty } = await getTeamRanking(round);
		this.setState({ ranking, isEmpty });
	}

	private renderEmpty = () => <div {...styles.empty}>This ranking is still empty...</div>;

	public render() {
		const round = this.props.match.params.round;
		const showLoading = this.state.ranking.length === 0 && !this.state.isEmpty;
		const showEmpty = this.state.ranking.length === 0 && this.state.isEmpty;
		return (
			<div {...styles.mobileMargin}>
				<H1 {...styles.title}>Ranking Round {round}</H1>
				{showLoading ? (
					<Loading />
				) : showEmpty ? (
					this.renderEmpty()
				) : (
					<Card>
						<div {...styles.container}>
							<HTMLTable {...styles.table} striped={true}>
								<thead>
									<tr>
										<th>Rank</th>
										<th>Team</th>
										<th>Points</th>
									</tr>
								</thead>
								<tbody>
									{this.state.ranking.map((team, i) => (
										<tr key={team.name}>
											<td>{i + 1}</td>
											<td>{team.name}</td>
											<td>{team.points}</td>
										</tr>
									))}
								</tbody>
							</HTMLTable>
						</div>
					</Card>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Public/TeamRanking.tsx